import React from "react";
import CloseIcon from "../../../../assets/icons/close.svg";

/** Route PAF shell: white card, close control, main column (typically scroll region + footer). */
export function PafFormCard({ onClose, children }) {
  return (
    <div className="layout-modal relative w-[90%]" data-testid="paf-page-form-card">
      <div
        className="close-icon"
        onClick={onClose}
        data-testid="paf-page-close-button"
        role="button"
      >
        <img src={CloseIcon} alt="Close Icon" />
      </div>
      <div className="flex min-h-0 flex-col" data-testid="paf-page-form-content">
        {children}
      </div>
    </div>
  );
}
